import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Package, ArrowRight } from 'lucide-react';
export function OrderConfirmation() {
  const orderNumber = Math.floor(100000 + Math.random() * 900000);

  // Calculate estimated delivery (3-5 days from now)
  const deliveryDate = new Date();
  deliveryDate.setDate(deliveryDate.getDate() + 4);
  const formattedDate = deliveryDate.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });
  return <div className="pt-32 pb-16 bg-warmwhite min-h-screen flex items-center justify-center" data-id="element-1052" data-mp="1mo43y1ppkimu">
      <div className="container mx-auto px-4 sm:px-6 md:px-12 max-w-3xl" data-id="element-1053" data-mp="18ocnlubpyq5o">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-white p-8 sm:p-10 lg:p-16 rounded-[2rem] border border-softgray shadow-premium text-center" data-id="element-1054" data-mp="1cqgbxjjhlp8d">
          <div className="w-20 h-20 lg:w-24 lg:h-24 bg-forest/10 rounded-full flex items-center justify-center mx-auto mb-6 lg:mb-8" data-id="element-1055" data-mp="3ui69vjg39l2p">
            <CheckCircle className="w-10 h-10 lg:w-12 lg:h-12 text-forest" data-id="element-1056" data-mp="3pjwa0vjf5war" />
          </div>
          
          <h1 className="text-3xl lg:text-4xl font-serif font-bold text-navy mb-4" data-id="element-1057" data-mp="7ejbted42x0f">Thank you for your order!</h1>
          <p className="text-base lg:text-lg text-mediumgray mb-8 lg:mb-10 max-w-xl mx-auto" data-id="element-1058" data-mp="3b3k8wfwfmul">
            Your purchase directly supports Poch Global's mission. We've sent a confirmation email with your receipt and order details.
          </p>

          <div className="bg-warmwhite p-6 lg:p-8 rounded-2xl border border-softgray mb-8 lg:mb-10 text-left grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8" data-id="element-1059" data-mp="r1hbwluknjon">
            <div data-id="element-1060" data-mp="m2wc2nj8f20q">
              <div className="text-xs lg:text-sm font-bold text-mediumgray uppercase tracking-wider mb-2" data-id="element-1061" data-mp="m4h5g9tt8ex0">Order Number</div>
              <div className="text-lg lg:text-xl font-bold text-navy" data-id="element-1062" data-mp="v32nm3vddrx9">#{orderNumber}</div>
            </div>
            <div data-id="element-1063" data-mp="3ovao48hup3ne">
              <div className="text-xs lg:text-sm font-bold text-mediumgray uppercase tracking-wider mb-2" data-id="element-1064" data-mp="3ovtuqt21w5m4">Estimated Delivery</div>
              <div className="text-lg lg:text-xl font-bold text-navy flex items-center gap-2" data-id="element-1065" data-mp="3tun6afxs1mjn">
                <Package className="w-4 h-4 lg:w-5 lg:h-5 text-gold" data-id="element-1066" data-mp="1ortaierhwy9" /> <span className="text-sm lg:text-xl" data-id="element-1067" data-mp="6gt3lysdddln">{formattedDate}</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1068" data-mp="bf2ys9e3ge79">
            <Link to="/shop" className="px-6 lg:px-8 py-3 lg:py-4 bg-navy hover:bg-navy-light text-white rounded-full font-bold transition-all shadow-md flex items-center justify-center gap-2 text-sm lg:text-base" data-id="element-1069" data-mp="gepk7642t0r5">
              Continue Shopping <ArrowRight className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-1070" data-mp="pem12lk84vbn" />
            </Link>
            <button className="px-6 lg:px-8 py-3 lg:py-4 bg-white border-2 border-navy text-navy hover:bg-navy hover:text-white rounded-full font-bold transition-all flex items-center justify-center text-sm lg:text-base" data-id="element-1071" data-mp="2n6qe6bappfes">
              Track Order
            </button>
          </div>
        </motion.div>
      </div>
    </div>;
}